import {
  AssistantResponseStepAnswer,
  AssistantResponseTokenV2,
  Chat,
  FeedbackSummaryExample,
  FeedbackSummaryUserQuote,
} from 'generated/graphql';
import { OraclePrompt } from '../store/types';

export const mapChatResponseToOraclePromptByID = (chat: Chat) => {
  let promptByID: Record<string, OraclePrompt> = {};

  chat.responses.forEach((response) => {
    const stepAnswerByID: Record<string, AssistantResponseStepAnswer> = {};
    let userQuoteByExampleID: {
      [exampleID: string]: {
        [recordID: string]: FeedbackSummaryUserQuote;
      };
    } = {};
    let eqlByTokenV2ID: Pick<OraclePrompt, 'eqlByTokenV2ID'> = {};
    let feedbackSummaryExampleByID: {
      [exampleID: string]: FeedbackSummaryExample;
    } = {};
    let artefactDetailsByTokenID: Record<string, AssistantResponseTokenV2> = {};

    response.steps?.forEach((step) => {
      stepAnswerByID[step.id] = { ...step.answer };

      step.answer.tokensV2.forEach((tokenV2) => {
        eqlByTokenV2ID = {
          ...eqlByTokenV2ID,
          [tokenV2.id]: tokenV2.eql,
        };

        if (tokenV2.text?.summaryDetails?.examples?.id) {
          feedbackSummaryExampleByID[
            tokenV2.text?.summaryDetails?.examples?.id
          ] = tokenV2.text?.summaryDetails?.examples;
        }
      });
    });

    response.answer.userQuote?.forEach((quote) => {
      userQuoteByExampleID[quote.exampleID] = {
        [quote.recordID]: { ...quote },
      };
    });

    response.answer.tokensV2.forEach((tokenV2) => {
      eqlByTokenV2ID = {
        ...eqlByTokenV2ID,
        [tokenV2.id]: tokenV2.eql,
      };

      if (tokenV2.text?.summaryDetails?.examples?.id) {
        feedbackSummaryExampleByID[tokenV2.text?.summaryDetails?.examples?.id] =
          tokenV2.text?.summaryDetails?.examples;
      }

      if (tokenV2.artefact) {
        artefactDetailsByTokenID = {
          ...artefactDetailsByTokenID,
          [tokenV2.id]: tokenV2,
        };
      }
    });

    const prompt: OraclePrompt = {
      ...response,
      error: response.error
        ? {
            code: '',
            message: response.error,
          }
        : undefined,
      endOfResponse: true,
      assistantResponse: {
        answer: response.answer,
        stepAnswerByID: stepAnswerByID,
        steps: response.steps?.map(({ __typename, ...step }) => ({
          ...step,
        })),
      },
      feedbackSummaryExampleByID,
      userQuoteByExampleID,
      eqlByTokenV2ID,
      artefactDetailsByTokenID,
    };

    promptByID[response.id] = prompt;
  });

  return promptByID;
};
